<template>
  <side-extended-panel 
    id="checkout-faq-sidebar"
    title="FAQ"
    :visible="show"
    size="small"
    @close="close"
  >
    <div class="py-4">
      <p class="text-muted mb-4">Frequently asked questions about our plans and subscriptions.</p>
      
      <div class="faq-list">
        <mbg-accordion-item 
          v-for="(faq, index) in faqs" 
          :key="faq.id || index"
          :text="faq.title" 
          :content="faq.content" 
          :open="activeFaq === index"
          title-classes="font-500"
          override-open
          reverse-background
          @click="activeFaq = activeFaq === index ? null : index"
        />
      </div>
    </div>
  </side-extended-panel>
</template>

<script>
import SideExtendedPanel from "../SideExtendedPanel.vue";
import MbgAccordionItem from "@/components/elements/MbgAccordionItem.vue";
import ServerContentMixin from "@/mixins/ServerContentMixin";
import { SidebarVariants } from "@/utils/localStorage";

export default {
  components: { SideExtendedPanel, MbgAccordionItem },
  mixins: [ServerContentMixin],
  
  data() {
    return {
      activeFaq: 0
    };
  },
  
  computed: {
    show() {
      return this.$store.state.ui.sideSheet.type === SidebarVariants.CheckoutFaqSidebar;
    },
    
    faqs() {
      return this.getByKey('checkout.faq', true) || [];
    }
  },
  
  methods: {
    close() {
      this.$store.commit('ui/CLOSE_SIDE_SHEET');
    }
  }
};
</script>

<style lang="scss" scoped>
.faq-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
</style>
